"use client";

import Image from "next/image";
import Reveal from "../../enterprise/components/Reveal";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import Link from "next/link";

const HyraAiSection = () => {
  const t = useTranslations("ecosystem");
  return (
    <section className="mx-auto flex max-w-[1440px] px-[78px] py-[120px] max-lg:flex-col max-lg:gap-10 max-lg:px-10 max-lg:py-[56px] max-sm:px-4">
      <div className="flex w-1/2 flex-col justify-between max-lg:w-full">
        <div className="w-3/4">
          <p className="font-open-sans text-base font-normal text-[#06f]">
            {t("trending-this-month")}
          </p>
          <Reveal
            delay={0.1}
            duration={0.8}
            direction="left"
            withBlur={true}
            blurAmount={8}
          >
            <h2 className="mt-8 text-[48px]/[56px] tracking-[-1px] max-lg:text-[32px]/[40px]">
              HYRA AI
            </h2>
          </Reveal>
          <Reveal
            delay={0.5}
            duration={0.8}
            direction="left"
            withBlur={true}
            blurAmount={8}
          >
            <p className="my-4 text-2xl tracking-[-0.5px] max-lg:text-lg">
              {t("ai-edge-computing-sharing-economy")}
            </p>
          </Reveal>
          <Reveal
            delay={0.8}
            duration={0.8}
            direction="left"
            withBlur={true}
            blurAmount={8}
          >
            <p className="text-base text-[#646464] max-lg:text-sm">
              {t(
                "join-the-global-edge-computing-system-to-earn-more-hyra-now-connects-all-edge-devices-such-as-smartphones-smarttvs-pcs-laptops-and-electric-cars",
              )}
            </p>
          </Reveal>
          <Link target="_blank" href={"https://ai.hyra.network/"}>
            <motion.div
              initial={{ opacity: 0, translateY: 40 }}
              whileInView={{ opacity: 1, translateY: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              viewport={{ once: true }}
              className="w-[45%] max-lg:hidden"
            >
              <button className="mt-8 flex items-center gap-2 rounded-xl border border-[#E9F3FF] px-5 py-[18px] text-base text-[#06f]">
                {t("discover-more")}
                <Image
                  src={"/images/icons/arrow-up-right.svg"}
                  width={20}
                  height={20}
                  alt="arrow icon"
                />
              </button>
            </motion.div>
          </Link>
        </div>
        <div>
          <div className="flex flex-wrap justify-center sm:justify-start gap-5 max-lg:mt-12">
            <Link
              target="_blank"
              href="https://apps.apple.com/vn/app/hyra-ai-ai-on-edge-computing/id6480506714"
            >
              <Image
                src={"/images/backgrounds/appstore.svg"}
                width={158}
                height={56}
                alt="arrow icon"
                className="cursor-pointer"
              />
            </Link>
            <Link
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.hyratek.salala"
            >
              <Image
                src={"/images/backgrounds/chplay.svg"}
                width={158}
                height={56}
                alt="arrow icon"
                className="cursor-pointer"
              />
            </Link>
            <button className="flex items-center gap-2 text-nowrap rounded-xl border border-[#E9F3FF] px-5 py-[18px] text-base text-[#06f] lg:hidden">
              {t("discover-more")}
              <Image
                src={"/images/icons/arrow-up-right.svg"}
                width={20}
                height={20}
                alt="arrow icon"
              />
            </button>
          </div>
        </div>
      </div>
      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
        className="relative w-1/2 max-lg:w-full"
      >
        {/* <div className="w-1/2 relative"> */}
        <Image
          src={"/images/backgrounds/phone-eco.png"}
          width={500}
          height={500}
          alt="thumbnail"
          className="aspect-square w-full"
        />
        <Image
          src={"/images/backgrounds/iphone16-eco.svg"}
          width={500}
          height={500}
          alt="iphone"
          className="absolute left-1/2 top-[70px] -translate-x-1/2"
        />
        {/* </div> */}
      </motion.div>
    </section>
  );
};

export default HyraAiSection;
